// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { io } from 'socket.io-client';

// const SocketContext = createContext();

// export const SocketProvider = ({ children }) => {
//     const [socket, setSocket] = useState(null);
    

//     useEffect(() => {
//         // Подключение к серверу
//         const newSocket = io('http://91.186.196.251:8081/', {
//             reconnection: true,           // Включить автоматическое переподключение
//             reconnectionAttempts: 5,      // Максимальное количество попыток переподключения
//             reconnectionDelay: 3000,      // Задержка между попытками переподключения
//             reconnectionDelayMax: 5000,   // Максимальная задержка между попытками
//             timeout: 10000,  
//         });

//         setSocket(newSocket);
        
//         return () => {
//             newSocket.disconnect();
//         };
//     }, []);

//     return (
//         <SocketContext.Provider value={socket}>
//             {children}
//         </SocketContext.Provider>
//     );
// };

// // Кастомный хук для использования сокета
// export const useSocket = () => {
//     return useContext(SocketContext);
// };

import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

// Контекст для подключения к Socket.IO
const SocketContext = createContext();

// Контекст для управления данными из события 'data'
const DataContext = createContext();

// Провайдер для подключения к Socket.IO
export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Подключение к серверу
        const newSocket = io(`${import.meta.env.VITE_API_URL}`, {
            reconnection: true,           // Включить автоматическое переподключение
            reconnectionAttempts: 5,      // Максимальное количество попыток переподключения
            reconnectionDelay: 3000,      // Задержка между попытками переподключения
            reconnectionDelayMax: 5000,   // Максимальная задержка между попытками
            timeout: 10000,  
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            <DataProvider socket={socket}>{children}</DataProvider>
        </SocketContext.Provider>
    );
};

// Провайдер для управления данными из события 'data'
export const DataProvider = ({ children, socket }) => {
    const [resultData, setResultData] = useState(null);
    const [isGameState, setIsGameState] = useState(null);
    useEffect(() => {
        if (!socket) return;

        const handleData = (res) => {
            setResultData(res.value); // Обновление данных при получении события
            
        };
        const gameState = (res) => {
            setIsGameState(res);
        }
        socket.on('data', handleData);
        socket.on('gameState', gameState)
        return () => {
            socket.off('data', handleData); // Очистка обработчика при размонтировании
            socket.off('gameState', gameState)
        };
    }, [socket]);

    return (
        <DataContext.Provider value={{resultData, isGameState}}>
            {children}
        </DataContext.Provider>
    );
};

// Кастомный хук для использования сокета
export const useSocket = () => {
    return useContext(SocketContext);
};

// Кастомный хук для использования данных из события 'data'
export const useData = () => {
    return useContext(DataContext);
};